"use client";

import { cn } from "@tosize/ui";
import { type ReactNode, useState } from "react";

interface Props {
	defaultThumb?: "on" | "off";
	on: {
		value: string;
		title: string;
		content: ReactNode;
	};
	off: {
		value: string;
		title: string;
		content: ReactNode;
	};
	className?: string;
}

export function TabSwitch({ defaultThumb = "off", on, off, className }: Props) {
	const defaultValue = defaultThumb === "on" ? on.value : off.value;
	const [value, setValue] = useState<string>(defaultValue);

	return (
		<>
			<div
				className={cn(
					"relative grid grid-cols-2 gap-2 rounded bg-white p-1 transition-all first:child:hover:bg-primary-dark",
					className,
				)}
			>
				<span
					className={cn(
						"pointer-events-none absolute top-1 bottom-1 w-[calc((100%-1rem)/2)] rounded bg-primary-medium transition-all",
						{
							"translate-x-[calc(100%+0.75rem)]": value === on.value,
							"translate-x-1": value !== on.value,
						},
					)}
				/>

				<button
					type="button"
					className={cn("z-1 appearance-none rounded p-1 leading-tight", {
						"text-white": value === off.value,
					})}
					onClick={() => setValue(off.value)}
				>
					{off.title}
				</button>

				<button
					type="button"
					className={cn("z-1 appearance-none rounded p-1 leading-tight", {
						"text-white": value === on.value,
					})}
					onClick={() => setValue(on.value)}
				>
					{on.title}
				</button>
			</div>

			{value === on.value ? on.content : off.content}
		</>
	);
}
